module.exports = __webpack_public_path__ + "media/images/back-caa283d02aaafbb30a4e1c8270a58153.svg";